import { ClassNameProps, Column, formatDateTime, makeClassName, Row, StyleProps } from "@hex-insights/core";
import styles from "./styles.module.css";

export type BigDateProps = {
	date?: Date;
} & Partial<ClassNameProps & StyleProps>;

export function BigDate({ date = new Date(), className, style }: BigDateProps) {
	return (
		<div className={makeClassName(styles["big-date"], className)} style={style}>
			<Column>
				<div className={styles["big-date__weekday"]}>{formatDateTime(date, "dddd")}</div>
				<Row justify="spaced-start" align="center" className={styles["big-date__main-row"]}>
					<div className={styles["big-date__month"]}>{formatDateTime(date, "MMMM")}</div>
					<div className={styles["big-date__day"]}>{formatDateTime(date, "D")}</div>
				</Row>
			</Column>
		</div>
	);
}
